// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kGU0","label":"styles_label__33b7x"};